/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

import {
  PolymerElement,
  html
} from "@polymer/polymer/polymer-element.js";
import {
  OEFieldMixin
} from "oe-mixins/oe-field-mixin.js";
class confirmPin extends PolymerElement {
  static get properties() {
    return {
      confirmPin: {
        type: String,
        notify: true,
        observer: '_checkPin'
      },
      newpin: {
        type: String,
        notify: true,
        observer: '_checkPin'
      },
      maxlength: {
        type: Number,
        notify: true
      },
      errormessage: {
        type: String,
        notify: true
      },
      cardpin: {
        type: Number,
        notify: true
      },
      required: {
        type: Boolean,
        notify: true
      },
      label: {
        type: String,
        notify: true
      },
      validationErrorMessage: {
        type: String,
        notify: true
      },
      allowedPattern: {
        type: String,
        notify: true
      }
    };
  }

  static get template() {
    return html `
<style include="app-styles">
        #new{
  padding-right: 16px;
}
oe-input{
--paper-input-container:{
  position: relative;
  top: -19px;
}
  }
#confirm{
  padding-left : 16px;
}
</style>
<oe-ajax id="prpmCardPinLen" content-type="application/json" handle-as="json" method="get" on-response="prpmCardSuccess" on-error="cardpinlengthfixed"></oe-ajax> 
<oe-input allowed-pattern="{{allowedPattern}}" id="confirmPin" type="password" class="" required="{{required}}" label="{{label}}" value="{{confirmPin}}" maxlength={{maxlength}} 
           oncopy="return false" onpaste="return false" on-blur="_checkLength" char-counter></oe-input>
    `;
  }
  constructor() {
    super();
  }

  ready() {
    super.ready();
    this.$.prpmCardPinLen.url = "/api/propertyreferences?filter[where][appId]=BWY&filter[where][propertyName]=CARD_PIN_LENGTH";
    this.$.prpmCardPinLen.generateRequest();
    this.$.confirmPin.invalid = false;
  }
  prpmCardSuccess(event) {
    this.maxlength = event.detail.response[0].propertyValue;
  }
  cardpinlengthfixed(event) {
    this.cardpin = 4;
  }
  _checkPin() {
    if (this.confirmPin != undefined) {
      if (this.confirmPin === this.newpin) {
        this.$.confirmPin.invalid = false;
        this.setValidity(true, undefined);
      } else {
		if (this.confirmPin.length == this.maxlength) {
			this.$.confirmPin.invalid = true;
			this.$.confirmPin.errorMessage = this.validationErrorMessage;
		}
      }
    }
  }
  _validate() {
    var isValid = true;
    if (_.isUndefined(this.confirmPin) || _.isEmpty(this.confirmPin)) {
      this.$.confirmPin.invalid = true;
      this.$.confirmPin.errorMessage = getLabel(this.errormessage);
      this.setValidity(false, 'wrongValue');
      isValid = false;
    } else if (this.confirmPin.length != this.maxlength) {
      this.$.confirmPin.invalid = true;
      this.$.confirmPin.errorMessage = getLabel("m_pinLengthInvalid"); // this.setValidity(false, 'wrongValue');
      isValid = false;
    } else if (this.confirmPin != this.newpin || this.$.confirmPin.invalid) {
      this.$.confirmPin.invalid = true;
      this.$.confirmPin.errorMessage = this.validationErrorMessage;
      this.setValidity(false, 'wrongValue');
      isValid = false;
    }
    return isValid;
  }
  _checkLength() {
    this._validate();
  }

}
customElements.define('confirm-pin', OEFieldMixin(confirmPin));